import React from "react";
import { Modal, Row, Col } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import {
  ModalButtonContainer,
  GrantsPaymentContent,
  FundWrapper,
  GrantPaymentSectionTitle,
  GrantPaymentUnorderList,
  GarntPaymentUnorderListWrapper,
  GrantPaymentSignatureWrapper,
  GrantPaymentUnorderListContent,
  GrantPaymentLetterAddressWrapper,
  AgreedAgreementWrapper,
  ImageFloatRightDiv,
  GrantPaymentSSRTitle,
  GrantPaymentOrgName,
  HorizontalDivider,
  HorizontalDividerWrapper,
  FirstColumn,
  InfoContent,
  GrantContent,
  GrantContentItalic,
  SecondColumn,
  GrantAgreementTable,
  GrantTableHeader,
  tableFirstColumn,
  tablePaddingBorder,
  grantAmount,
  Finalitem,
  PaddingLeft,
  Img,
  GrantPaymentTable,
  FlexDiv,
  SignatureRow,
} from "./style";
// TODO - remove this
import "./style.css";
import logo from "../../../../../../../assets/icons/vcep-logo.png";
import formatter from "../../../../../../../utils/formatter";
import { GeneralButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
export class GrantAgreementDocPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true,
      reportingRequired: false,
    };
  }

  closeModal = () => {
    this.setState(
      {
        visible: false,
      },
      () => {
        this.props.closePreview();
      }
    );
  };

  render() {
    return (
      <Modal
        id="grantPaymentDocument"
        width="75%"
        visible={this.state.visible}
        onCancel={this.closeModal.bind(this)}
        footer={[
          <ModalButtonContainer>
            <GeneralButton
              type="functional"
              inverted={true}
              width="150px"
              onClick={this.closeModal.bind(this)}
              text="Close"
            />
          </ModalButtonContainer>,
        ]}
      >
        <ImageFloatRightDiv>
          {" "}
          <Img src={logo} alt="vanguard-logo" />
        </ImageFloatRightDiv>
        <GrantPaymentSSRTitle>
          Grant Agreement (Single Standard Reporting)
        </GrantPaymentSSRTitle>
        <GrantPaymentOrgName>
          {this.props.grantPaymentData.organizationName}
        </GrantPaymentOrgName>
        <div className="agreementPreviewOverlay">
          <GrantPaymentSectionTitle>I. Introduction</GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            This grant agreement (the “Agreement”) summarizes the mutual
            understanding of the Vanguard Charitable Endowment Program (the
            “Grantor”) and the {this.props.grantPaymentData.granteeName}
            (the “Grantee”) regarding the terms and conditions of a grant to
            support {this.props.grantPaymentData.grantPurpose}, 1 (the “Grant
            Purpose”).
          </GrantsPaymentContent>
          <GrantPaymentSectionTitle>
            II. Amount and Purpose of Grant
          </GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            The Grantor has approved a grant of{" "}
            {this.props.grantPaymentData.grantAmount} to the Grantee (the
            “Grant”) for the Grant Purpose. The funds will be disbursed as
            specified below, contingent on the Grantee’s satisfaction of the
            requirements of this Agreement, including the terms and conditions
            set forth in the Grant payment letter, attached hereto as Exhibit 2
            (the “Grant Payment Letter”).
            {this.props.grantPaymentData.anonymous ? (
              <>anonymous</>
            ) : (
              <FundWrapper>
                {this.props.grantPaymentData.accountName}
              </FundWrapper>
            )}{" "}
            (the “Donor Advisors”) recommended that Grantor make this Grant with
            funds held in a donor-advised account at Vanguard Charitable (the
            “Account”).
          </GrantsPaymentContent>

          <GrantsPaymentContent>
            The Grantee agrees that it will use the Grant funds exclusively for
            the Grant Purpose and that the Grant Purpose is in furtherance of
            the Grantee’s tax-exempt purposes within the meaning of Section
            501(c)(3) of the Internal Revenue Code of 1986, as amended (the
            “Code”). Grant funds that are not expended or committed for the
            Grant Purpose or which are expended for any purpose that violates
            the terms of this Agreement, including the Grant Payment Letter,
            must be returned to the Grantor
          </GrantsPaymentContent>
          <GrantPaymentSectionTitle>
            III. Tax Status of Grantee
          </GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            The Grantee represents that it is recognized as a tax-exempt,
            charitable organization described in Section 501(c)(3) and
            classified as a [public charity or private foundation] under
            [Section 509(a)(1), 509(a)(2), etc.) with a Federal ID of{" "}
            {this.props.grantPaymentData.ein}. The Grantee will immediately
            notify the Grantor of any change in its tax status
          </GrantsPaymentContent>

          <GrantPaymentSectionTitle>
            IV. Disbursement of Grant Funds
          </GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            Payment schedule: Grantor will disburse Grant funds in one
            installment as set forth below (the “Payment schedule”):
          </GrantsPaymentContent>
          {this.props.grantPaymentData.payments &&
          this.props.grantPaymentData.payments.length ? (
            <GrantAgreementTable>
              <GrantTableHeader>
                <FlexDiv>
                  <Col span={14} style={tableFirstColumn}>
                    Disbursement date
                  </Col>
                  <Col span={10} style={PaddingLeft}>
                    Amount
                  </Col>
                </FlexDiv>
              </GrantTableHeader>
              <GrantPaymentTable>
                {this.props.grantPaymentData.payments &&
                this.props.grantPaymentData.payments.length === 1 ? (
                  <>
                    <FlexDiv>
                      <Col span={14} style={tableFirstColumn}>
                        Upon signing of the Grant Agreement
                      </Col>
                      <Col span={10} style={PaddingLeft}>
                        {formatter({
                          value: this.props.grantPaymentData.payments[0].amount,
                          fieldSuffix: "Dollars",
                        })}
                      </Col>
                    </FlexDiv>
                  </>
                ) : (
                  <>
                    {this.props.grantPaymentData.payments.map((item, index) => (
                      <>
                        {this.props.grantPaymentData.payments.length - 1 ==
                        index ? (
                          <div
                            key={item.grantAmountStr + item.intendedPaymentDate}
                          >
                            <FlexDiv>
                              <Col span={14} style={tableFirstColumn}>
                                {moment(item.requestedDate).format(
                                  "MMMM D, YYYY"
                                )}
                              </Col>
                              <Col span={10} style={PaddingLeft}>
                                {formatter({
                                  value: item.amount,
                                  fieldSuffix: "Dollars",
                                })}
                              </Col>
                            </FlexDiv>
                          </div>
                        ) : (
                          <div
                            key={item.grantAmountStr + item.intendedPaymentDate}
                          >
                            <FlexDiv>
                              <Col span={14} style={tablePaddingBorder}>
                                {moment(item.requestedDate).format(
                                  "MMMM D, YYYY"
                                )}
                              </Col>
                              <Col span={10} style={grantAmount}>
                                {formatter({
                                  value: item.amount,
                                  fieldSuffix: "Dollars",
                                })}
                              </Col>
                            </FlexDiv>
                          </div>
                        )}
                      </>
                    ))}
                  </>
                )}
              </GrantPaymentTable>
            </GrantAgreementTable>
          ) : null}

          <GrantPaymentSectionTitle>V. Recognition</GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            The Grantee may acknowledge this Grant in the Grantee’s publications
            and press releases. Recognition of this Grant shall identify the
            Grantor as Vanguard Charitable.
          </GrantsPaymentContent>
          {this.props.grantPaymentData.dues &&
          this.props.grantPaymentData.dues.length ? (
            <>
              <GrantPaymentSectionTitle>VI. Reporting</GrantPaymentSectionTitle>
              <GrantsPaymentContent>
                The Grantee shall provide the Grantor with periodic reports
                detailing the Grantee’s use of the Grant funds and the progress
                made toward the goals of the Project. The reports shall be due
                as follows:
              </GrantsPaymentContent>
              {this.props.grantPaymentData.dues &&
              this.props.grantPaymentData.dues.length ? (
                <GrantAgreementTable>
                  <GrantTableHeader>
                    <FlexDiv>
                      <Col span={14} style={tableFirstColumn}>
                        Due date
                      </Col>
                      <Col span={10} style={PaddingLeft}>
                        Type of Report
                      </Col>
                    </FlexDiv>
                  </GrantTableHeader>

                  <GrantPaymentTable>
                    {this.props.grantPaymentData.dues &&
                    this.props.grantPaymentData.dues.length ? (
                      <>
                        {this.props.grantPaymentData.dues.map(
                          (item, index) =>
                            item.reportRequirement && (
                              <div
                                key={
                                  item.grantAmountStr + item.intendedPaymentDate
                                }
                              >
                                <FlexDiv>
                                  {this.props.grantPaymentData.dues.length -
                                    1 ==
                                  index ? (
                                    <Col span={14} style={tableFirstColumn}>
                                      {moment(
                                        item.grantRequirementDueDate
                                      ).format("MMMM D, YYYY")}
                                    </Col>
                                  ) : (
                                    <Col span={14} style={tablePaddingBorder}>
                                      {moment(
                                        item.grantRequirementDueDate
                                      ).format("MMMM D, YYYY")}
                                    </Col>
                                  )}
                                  {this.props.grantPaymentData.dues.length -
                                    1 ==
                                  index ? (
                                    <Col span={10} style={Finalitem}>
                                      Final
                                    </Col>
                                  ) : (
                                    <Col span={10} style={grantAmount}>
                                      Interim
                                    </Col>
                                  )}
                                </FlexDiv>
                              </div>
                            )
                        )}
                      </>
                    ) : null}
                  </GrantPaymentTable>
                </GrantAgreementTable>
              ) : null}

              <GrantsPaymentContent>
                The reports should be sent to the Grants Department at the
                following email address:
                <p>
                  <a href={`mailto:grants@vanguardcharitable.org`}>
                    grants@vanguardcharitable.org.
                  </a>
                </p>
              </GrantsPaymentContent>
            </>
          ) : null}

          <GrantPaymentSectionTitle>
            {`${
              this.props.grantPaymentData.dues &&
              this.props.grantPaymentData.dues.length
                ? "VII"
                : "VI"
            }. Limitation of Liability; Use of Grant Funds`}
          </GrantPaymentSectionTitle>
          <GrantsPaymentContent>
            Notwithstanding any contrary provision contained herein: (i) the
            Grantor shall have no obligation to make any payment under this
            Agreement if doing so would violate any law, rule, or regulation
            applicable to the Grantor, or any interpretation of the foregoing by
            any governmental authority (including the Internal Revenue Service),
            including any law, rule, regulation or interpretation adopted after
            the effective date of this Agreement and (ii) the Grantor shall not
            be obligated on any disbursement date to disburse an amount greater
            than the balance on that date in the Account.
          </GrantsPaymentContent>

          <GrantsPaymentContent>
            The Grantee further agrees to use all grant funds for the Grant
            Purpose and to maintain any unspent grant funds in a fund or account
            in a bank or investment firm that is a member of either the FDIC or
            SIPC. Such investment will be in accordance with the Grantee’s
            governing documents and investment policies so long as they do not
            conflict with this Agreement, with the laws of the State of
            Delaware, and with federal laws. Any interest earned on the
            investment of grant funds must be tracked and used solely for the
            Grant Purpose or reinvested in the same account. The Grantee may not
            assess an administrative or financial management fee unless agreed
            to in writing and in advance by Vanguard Charitable.
          </GrantsPaymentContent>

          <GrantPaymentSectionTitle>
            {`${
              this.props.grantPaymentData.dues &&
              this.props.grantPaymentData.dues.length
                ? "VIII"
                : "VII"
            }. Miscellaneous`}
          </GrantPaymentSectionTitle>
          <GarntPaymentUnorderListWrapper>
            <div>
              <GrantPaymentUnorderList>
                • Applicable Law:
              </GrantPaymentUnorderList>
              <GrantPaymentUnorderListContent>
                {" "}
                This Agreement is executed in and shall be governed by the laws
                of the State of Pennsylvania.
              </GrantPaymentUnorderListContent>
            </div>
            <br></br>
            <div>
              <GrantPaymentUnorderList>• Amendment:</GrantPaymentUnorderList>
              <GrantPaymentUnorderListContent>
                {" "}
                This Agreement may be amended at any time by written agreement
                signed by each party.
              </GrantPaymentUnorderListContent>
            </div>
            <br></br>
            <div>
              <GrantPaymentUnorderList>• Termination:</GrantPaymentUnorderList>
              <GrantPaymentUnorderListContent>
                {" "}
                Vanguard Charitable and Grantee may terminate this grant at any
                time, with or without cause, upon written notification to the
                other party by [certified] mail to the addresses listed on this
                agreement. Upon such notification, Grantee will (1) immediately
                cease new project expenditures and commitments, and (2) within
                30 days following notification provide complete project
                accounting records through the date of project cancellation and
                to return unspent grant funds to Vanguard Charitable. Grantee
                and Vanguard Charitable shall have 30 days to correspond
                concerning the circumstances leading to the cancellation of the
                project and may mutually agree, in writing, to any modifications
                of the terms of this agreement.
              </GrantPaymentUnorderListContent>
            </div>
            <br></br>
            <div>
              <GrantPaymentUnorderList>
                • Effective Date:
              </GrantPaymentUnorderList>
              <GrantPaymentUnorderListContent>
                {" "}
                The effective date of this Agreement shall be the date this
                Agreement is countersigned by the Grantee below.
              </GrantPaymentUnorderListContent>
            </div>
            <br></br>
          </GarntPaymentUnorderListWrapper>
          <GrantsPaymentContent>
            If this Agreement correctly sets forth your understanding of the
            terms and conditions of this Grant, please countersign and return
            the attached copy of this Agreement to:
          </GrantsPaymentContent>
          <GrantPaymentLetterAddressWrapper>
            <div>Grants Department</div>
            <div>Vanguard Charitable</div>
            <div>P.O. Box 9509</div>
            <div>Warwick, RI 02889-9509</div>
            <a href={`mailto:grants@vanguardcharitable.org`}>
              grants@vanguardcharitable.org
            </a>
          </GrantPaymentLetterAddressWrapper>

          <AgreedAgreementWrapper>
            <GrantPaymentUnorderList>
              Agreed and Accepted By:
            </GrantPaymentUnorderList>
          </AgreedAgreementWrapper>
          <GrantPaymentSignatureWrapper>
            <SignatureRow>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                xxl={8}
                className="signatureItems"
              >
                Vanguard Charitable Endowment Program
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={8}
                xxl={10}
                className="grantAgreementRowSpacing"
              ></Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={10}
                xl={8}
                xxl={6}
                className="grantSignatureGranteeName"
              >
                {this.props.grantPaymentData.granteeName}
              </Col>
            </SignatureRow>
            <Row>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={14}
                xl={8}
                xxl={8}
                className="grantAgreementSignatureTop signatureItems"
              >
                <span>Signature: </span> _____________________
                <p>[Authorized Vanguard Charitable Signer]</p>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={0}
                xl={8}
                xxl={10}
                className="grantAgreementRowSpacing"
              ></Col>
              <Col xs={24} sm={24} md={24} lg={10} xl={8} xxl={6}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  className="grantAgreementSignature signatureItems"
                >
                  <span>Signature: </span>_____________________
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  className="grantAgreementSignature grantAgreementSignatureTop signatureItems"
                >
                  <span>Print name: </span> _____________________
                </Col>
              </Col>
            </Row>
            <Row>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                xxl={8}
                className="grantAgreementSignatureTop signatureItems"
              >
                <span>Date: </span> _____________________
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={8}
                xxl={10}
                className="grantAgreementRowSpacing"
              ></Col>
              <Col xs={24} sm={24} md={24} lg={10} xl={8} xxl={6}>
                <Col
                  md={24}
                  lg={24}
                  xl={24}
                  className="grantAgreementSignature signatureItems grantSignatureTitle"
                >
                  <span>Title: </span> _____________________
                </Col>
                <Col
                  md={24}
                  lg={24}
                  xl={24}
                  className="grantAgreementSignature grantAgreementSignatureTop signatureItems"
                >
                  <span>Date: </span> _____________________
                </Col>
              </Col>
            </Row>
          </GrantPaymentSignatureWrapper>
        </div>

        <HorizontalDividerWrapper>
          <HorizontalDivider />
        </HorizontalDividerWrapper>
        <div>
          <Row>
            <ImageFloatRightDiv>
              {" "}
              <Img src={logo} src="vanguard-logo" />
            </ImageFloatRightDiv>
            <GrantPaymentSSRTitle>Exibit 2</GrantPaymentSSRTitle>
            <GrantPaymentOrgName>
              {this.props.grantPaymentData.organizationName}
            </GrantPaymentOrgName>
            <FirstColumn lg={11} sm={12} xs={24}>
              <InfoContent>
                Important information about grants from Vanguard Charitable
              </InfoContent>
              <InfoContent>Prohibited benefits</InfoContent>
              <GrantContent>
                Grants from Vanguard Charitable are to be used for charitable
                and other tax-exempt purposes. Such grants may not be used to
                confer a Prohibited Benefit to any Disqualified Person. A
                Disqualified Person includes the recommending donor, his or her
                family members, and certain entities that they own or control.
              </GrantContent>
              <GrantContent>
                A Prohibited Benefit is any benefit that is more than incidental
                and would have the effect of reducing the amount that a
                recommending donor could otherwise deduct as a charitable
                contribution if the recommending donor had made the donation
                directly from personal funds. Prohibited Benefits may include
                cash, goods, or services received as a result of a distribution
                from a donor-advised fund. Illustrative examples include, but
                are not limited to, tickets, vouchers, or admission to
                performances, sporting events, or other events; items purchased
                at charitable auctions; payment of club dues, school tuition,
                and legally binding obligations.
              </GrantContent>
              <GrantContentItalic>
                By accepting a grant from Vanguard Charitable, you certify that
                the grant will not confer a Prohibited Benefit to any
                Disqualified Persons.
              </GrantContentItalic>
              <InfoContent>
                No bifurcation to acquire prohibited benefits
              </InfoContent>
              <GrantContent>
                Grants from Vanguard Charitable may not be used to enable a
                Disqualified Person to purchase a Prohibited Benefit with
                personal funds if such Prohibited Benefit would not have been
                available for purchase but for the grant.
              </GrantContent>
              <GrantContentItalic>
                By accepting a grant from Vanguard Charitable, you certify that
                the grant will not be used to enable a Disqualified Person to
                purchase an otherwise Prohibited Benefit using personal funds.
              </GrantContentItalic>
              <InfoContent>Pledges and other legal obligations</InfoContent>
              <GrantContent>
                Grants from Vanguard Charitable may not be used to pay any legal
                obligation that a Disqualified Person owes to a charity. A
                legally binding pledge to make a gift is an example of such an
                obligation. If you are not sure whether a Disqualified Person
                has entered into a legally binding contract to make a gift,
                please contact Vanguard Charitable.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that the grant will not be used to pay any legally binding
                pledge or other legal obligation that a Disqualified Person owes
                to your organization.
              </GrantContentItalic>
              <InfoContent>Grant recognition</InfoContent>
              <GrantContent>
                The attached grant is from a donor-advised fund sponsored by
                Vanguard Charitable.It is not a gift directly from the
                recommending donor or account advisor's personal
                funds.Accordingly, any public
              </GrantContent>
            </FirstColumn>
            <SecondColumn lg={11} sm={11} xs={24}>
              <GrantContent>
                statements acknowledging the grant should credit Vanguard
                Charitable as the source of the funds.Such statements may
                acknowledge the account named in the attached letter as the
                source of the grant recommendation unless otherwise specified on
                page one of this letter.
              </GrantContent>
              <InfoContent>No additional charitable deduction</InfoContent>
              <GrantContent>
                Donors should have already claimed a charitable contribution
                deduction when they made a gift to Vanguard Charitable. No
                additional deduction is permitted when Vanguard Charitable makes
                grants to other organizations. Accordingly, you should not send
                a charitable contribution tax deduction substantiation letter to
                any individual, organization, or entity in connection with this
                grant.
              </GrantContent>
              <InfoContent>No lobbying purpose</InfoContent>
              <GrantContent>
                Grants from Vanguard Charitable generally may not be used to
                support lobbying. Prohibited lobbying includes direct or
                grassroots lobbying communications that reflect a view of
                support or opposition on a specific legislative proposal. If you
                are uncertain whether an activity is prohibited lobbying, please
                contact Vanguard Charitable.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that none of the grant funds will be used for direct or
                grassroots lobbying.
              </GrantContentItalic>
              <InfoContent>
                Scholarships, missionary support grants, and other grants to
                individuals
              </InfoContent>
              <GrantContent>
                Vanguard Charitable makes grants to other organizations, not to
                individuals. If your organization intends to use this grant to
                award scholarships or grants to individuals, you must (a)
                maintain discretion and control over the grant funds from
                Vanguard Charitable, (b) not award any scholarship to a
                Disqualified Person (including family members of any
                donor-advisor), and (c) not allow any Disqualified Person to
                select grant recipients.
              </GrantContent>
              <GrantContent>
                Any individuals recommended in connection with this grant are
                for your consideration only. This grant does not legally
                obligate you to award any scholarship or grant to any
                individual.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that your organization (a) will maintain discretion and control
                over the grant funds, (b) will not award any scholarship or
                grant to a Disqualified Person (including family members of any
                donor-advisor), and (c) has not and will not enter into any
                agreement, oral or written, whereby any Disqualified Person may
                cause the selection of any secondary grantee who is an
                individual. Grant recognition
              </GrantContentItalic>
              <InfoContent>Private non-operating foundations.</InfoContent>
              <GrantContent>
                Grants from Vanguard Charitable should not be made for the
                purpose of enabling an organization that is controlled by a
                Disqualified Person to avoid classification as a private
                non-operating foundation.
              </GrantContent>
            </SecondColumn>
          </Row>
          <HorizontalDivider />
          <Row>
            <FirstColumn lg={11} sm={11} xs={24}>
              <GrantContent>
                A private non-operating foundation is a charitable organization
                that is not a public charity and does not operate its own
                tax-exempt programs. Private non-operating foundations are
                subject to special tax rules.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant, you certify (a) that your organization
                is not controlled by Disqualified Persons and (b) that it would
                not be classified a private non-operating foundation without the
                support it has received from Vanguard Charitable, including this
                grant.
              </GrantContentItalic>
              <InfoContent>Fiscal sponsors</InfoContent>
              <GrantContent>
                Vanguard Charitable generally makes grants to organizations that
                the IRS has determined to be tax-exempt public charities. Some
                organizations that have not yet received IRS recognition of
                tax-exempt status raise funds through fiscal sponsorship
                arrangements with a recognized public charity. Vanguard
                Charitable makes grants to fiscal sponsors, provided that the
                fiscal sponsor maintains discretion and control over the funds.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that your organization maintains discretion and control over any
                grant funds used to support the fiscal sponsorship of another
                organization.
              </GrantContentItalic>
              <InfoContent>Disqualified supporting organizations</InfoContent>
              <GrantContent>
                Vanguard Charitable may not make grants to disqualified
                supporting organizations, including (a) non-functionally
                integrated Type III supporting organizations, and (b) supporting
                organizations that in turn support organizations that
                Disqualified Persons directly or indirectly control.
              </GrantContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that you are not a disqualified supporting organization.
              </GrantContentItalic>
              <InfoContent>U.S. Office of Foreign Assets Control</InfoContent>
              <GrantContentItalic>
                By accepting this grant from Vanguard Charitable, you certify
                that all grant funds will be used in compliance with all
                statutes, Executive Orders, and regulations restricting or
                prohibiting U.S. persons from engaging in transactions and
                dealings with countries, entities, and individuals subject to
                economic sanctions administered by the U.S. Department of the
                Treasury’s Office of Foreign Assets Control (OFAC).
              </GrantContentItalic>
              <GrantContent>
                For more information, visit
                <a href="https://www.treasury.gov" target="_blank">
                  www.treasury.gov
                </a>
                .
              </GrantContent>
              <InfoContent>Additional information</InfoContent>
              <GrantContent>
                Please refer to Vanguard Charitable’s Policies and guidelines
                booklet at www.vanguardcharitable.org/policies for more
                information on our granting review and distribution policies. If
                you have questions or concerns, please be sure to contact
                Vanguard Charitable as soon as possible.
              </GrantContent>
            </FirstColumn>
            <SecondColumn lg={11} sm={11} xs={24}>
              <InfoContent>
                Your organization is responsible for contacting Vanguard
                Charitable at 888-383-4483 if there are updates to the
                following: address or contact information used for purposes of
                mailing grants to your organization, tax-exempt status, or any
                other relevant changes.
              </InfoContent>
              <GrantContent>
                Vanguard Charitable was founded by The Vanguard Group, Inc.
                ("Vanguard"), as an independent, nonprofit, public charity in
                1997. Although Vanguard provides certain investment management
                and administrative services to Vanguard Charitable pursuant to a
                service agreement, Vanguard Charitable is not a program or
                activity of Vanguard. A majority of Vanguard Charitable’s
                Trustees are independent of Vanguard.
              </GrantContent>
            </SecondColumn>
          </Row>
        </div>
      </Modal>
    );
  }
}

GrantAgreementDocPreview.propTypes = {
  closePreview: PropTypes.func,
  grantPaymentData: PropTypes.object,
};
export default GrantAgreementDocPreview;
